import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DropzoneConfigInterface } from "ngx-dropzone-wrapper";
import { ToastrService } from "ngx-toastr";
import { FirmaFormState } from 'src/app/core/states/firma/firma.model';
import { Observable, Subscription } from 'rxjs';
import { FirmaStateService } from 'src/app/core/states/firma/firma-state.service';
import { Lote } from 'src/app/models/Lote.model';
import Swal, { SweetAlertIcon } from 'sweetalert2';

interface FileData {
  file: File;
  buffer: ArrayBuffer | null;
  base64: string | null;
}

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.css']
})
export class FileUploadComponent implements OnInit {

  @Input() files!: any;
  @Input() extension: any[] = [];
  @Input() maxFileSize: number = 10;
  @Input() multiple = false;
  @Input() maxFiles = 1;
  @Input() formatReturn = 'file';
  @Input() visible: boolean = true;
  @Output() fileSelected: EventEmitter<any> = new EventEmitter<any>();
  mesageExtension = '';
  selectedFiles: File[] = [];
  fileThumbnails: string[] = [];

  validateExtension: string[] = [];

  signatureState$: Observable<FirmaFormState>;
  lote$: Observable<Lote | null>; // Asegúrate de que esta propiedad exista
  private subscriptions: Subscription = new Subscription(); // Para gestionar las suscripciones


  constructor(private msgService: ToastrService, private firmaService: FirmaStateService) {
    this.signatureState$ = this.firmaService.firmaState$;
    this.lote$ = this.firmaService.lote$;
  }

  dzcProviderFile: DropzoneConfigInterface = {
    maxFiles: 3,
    acceptedFiles: '.bmp,.png,.jpg,.jpeg,.pdf,.js',
    autoProcessQueue: false,
    url: '/',
    errorReset: 3000,
    autoReset: 3000
  };

  // Toast
  toast = Swal;

  ngOnInit(): void {
    this.toastAlert();
    this.subscriptions.add( // Añade la suscripción al objeto de suscripciones
      this.lote$.subscribe(info => {
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe(); // Desuscribe todas las suscripciones añadidas a este objeto
  }

  onSelect(event: any): void {
    
    this.formatFile(event)

  }


  onRemove(file: File) {
    // Eliminar el archivo del array
    this.files = this.files.filter((f: any) => f !== file);

    switch (this.formatReturn) {
      case 'file':

        this.file(this.files);
        break;

      case 'buffer':
        this.buffer(this.files);
        break;

      case 'base64':
        this.base64(this.files);
        break;

      default:
        break;
    }
  }

  //CONFIGURACIONES

  extensionFiles(extension: any) {

    let result = '';

    if (extension.length > 0) {

      const mimeTypesObj: { [key: string]: string } = {
        'jpeg': 'image/jpeg',
        'jpg': 'image/jpeg',
        'png': 'image/png',
        'pdf': 'application/pdf',
        'word': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'excel': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'js': 'text/javascript'
      };

      const extensionesObj: { [key: string]: string } = {
        'jpeg': 'jpeg',
        'jpg': 'jpg',
        'png': 'png',
        'pdf': 'pdf',
        'word': 'word',
        'excel': 'excel',
        'js': 'js'
      };


      this.validateExtension = extension.map((extensions: any) => mimeTypesObj[extensions]);
      const mimeTypesExtension = extension.map((extensions: any) => extensionesObj[extensions]);


      this.mesageExtension = mimeTypesExtension.join(',');
      result = this.validateExtension.join(',');


    } else {
      result =
      'image/jpeg,image/jpg,image/png,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/javascript';
      this.mesageExtension = 'jpeg, jpg, png, pdf, word, excel, js';
    }

    return result;
  }

  formatFile(event: any) {
    const file: File[] = event.addedFiles;
    this.files = file;

    if (event.rejectedFiles.length > 0) {
      for (let j = 0; j < event.rejectedFiles.length; j++) {
        const file2 = event.rejectedFiles[j];
        this.alert('warning', `La extensión del archivo ${file2.name} no está permitida`);
      }
    }

    const maxSize = this.maxFileSize * 1024 * 1024;
    for (let i = 0; i < file.length; i++) {
      const files = file[i];
      if (files.size > maxSize) {

        file.splice(i, 1);
        i--;

        this.alert('warning', `El archivo ${files.name} excede el tamaño permitido`);
      }
    }

    if (this.maxFiles >= 1) {

      if (event.addedFiles.length > this.maxFiles) {

        this.alert('warning', `Solo se permiten ${this.maxFiles} archivos`);
        file.splice(this.maxFiles - file.length);

      }
    }

    this.files = file;
    switch (this.formatReturn) {
      case 'file':

        this.file(this.files);
        break;

      case 'buffer':
        this.buffer(this.files);
        break;

      case 'base64':
        this.base64(this.files);
        break;

      default:
        break;
    }


  }


  file(file: any) {

    if (this.multiple) {
      const fileList: FileList = this.convertirAFileList(file)
      this.fileSelected.emit(fileList);
    } else {
      this.fileSelected.emit(file[0]);
    }
  }

  buffer(file: any) {
    if (this.multiple) {
      const bufferArray: any = [];

      for (let i = 0; i < file.length; i++) {
        const files = file[i];

        const reader = new FileReader();

        reader.onload = (event: any) => {
          const buffer: ArrayBuffer = event.target.result;

          bufferArray.push(buffer);
        };


        reader.readAsArrayBuffer(files);
      }

      this.fileSelected.emit(bufferArray);

    } else {
      const reader = new FileReader();

      reader.onload = (event: any) => {
        const buffer: ArrayBuffer = event.target.result;
        // Aquí puedes trabajar con el buffer según tus necesidades
        this.fileSelected.emit(buffer);
      };

      reader.readAsArrayBuffer(file[0]);
    }
  }

  base64(file: any) {

    if (this.multiple) {
      const base64Array: any = [];

      for (let i = 0; i < file.length; i++) {
        const files = file[i];

        const reader = new FileReader();

        reader.onload = () => {
          const base64String = reader.result as string;

          base64Array.push(base64String);
        };


        reader.readAsDataURL(files);
      }

      this.fileSelected.emit(base64Array);
    } else {
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result as string;
        this.fileSelected.emit(base64);
      };
      reader.readAsDataURL(file[0]);
    }

  }

  onUploadError(error: any): void {
    try {
      switch (error[2].status) {
        case 403: // File extension not allowed
          this.msgService.warning(error[1].message);
          break;
        case 415: // F5: File type not allowed
          this.msgService.warning('El archivo cargado no está permitido. Si esto es un problema contacte al administrador');
          break;
        case 500: // Server error
          this.msgService.error(error[1].message);
          break;
        default:
          this.msgService.error('Vaya! Al parecer algo salió mal.');
      }
    } catch (e) {
      this.msgService.warning('Capacidad máxima alcanzada');
    }
  }



  convertirAFileList(file: any): FileList {
    const dataTransfer = new DataTransfer();

    file.forEach((file: any) => {
      dataTransfer.items.add(file);
    });
    return dataTransfer.files;
  }

  isValidFileType(fileType: string): boolean {
    // Validar tipos MIME de imágenes
    return /^image\//.test(fileType);
  }

  isValidFileExtension(fileType: any): boolean {

    return this.validateExtension.includes(fileType);
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
  }

  onDrop(event: any) {
    event.preventDefault();
    const files = event.dataTransfer?.files;
    this.handleFiles(files);
  }

  onFileSelected(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const files = inputElement.files;
    this.handleFiles(files);
  }

  private handleFiles(files: FileList | null) {
    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        this.selectedFiles.push(files[i]);
      }
    }
  }


  removeFile(index: number) {
    this.selectedFiles.splice(index, 1);
  }

  public clearFiles(): void {
    this.selectedFiles = [];
    this.files = [];
  }


  toastAlert() {
    this.toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      }
    });
  }

  alert(icontext: SweetAlertIcon, title: string) {
    this.toast.fire({
      icon: icontext,
      title: title
    });
  }
}
